module.exports = __webpack_public_path__ + "img/Background_3.a083d5f8.png";